<div class="row" style="margin-bottom: 20px;">
    <div *ngIf="attributes.title !== ''" class="col-lg-12 text-center">
        <h3 [ngStyle]="{'text-align': attributes.align ? attributes.align : 'center'}">{{attributes.title}}</h3>
        <h6 [ngStyle]="{'text-align': attributes.align ? attributes.align : 'center'}">{{attributes.subtitle}}</h6>
    </div>
    <div class="form-group col-lg-12">
        <controls-fabric [content]="data.content" [formGroup]="form"></controls-fabric>
    </div>
</div>